/**
 * Provider for `first_session`
 * @module
 */

var enums = require('core/behavior/enums');
var eventsHelper = require('../../helpers/events');
var getFieldValue = require('core/utils/key_path').getFieldValue;

var CURRENT_SESSION_INDEX = require('core/behavior/policy').CURRENT_SESSION_INDEX;

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'first_session',
  shouldTrack: true,

  getter: [
    function() {
      // getEvents returns events sorted in chronological order.
      var sortedEvents = eventsHelper.getEvents();
      if (sortedEvents && sortedEvents.length > 0) {
        var oldestEvent = sortedEvents[0];
        var oldestSessionIndex = getFieldValue(oldestEvent, [enums.FIELDS.SESSION_INDEX]);
        return oldestSessionIndex === CURRENT_SESSION_INDEX;
      }

      return true;
    },
  ],
};
